module.exports = __webpack_public_path__ + "img/add_sample_01.b5597cb4.png";